var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullpushcredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.800781,
    width: 43.4019,
    height: 43.4019,
    rx: 6,
    fill: "#F0F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6719 28.3929C11.6719 29.2802 12.4931 30 13.5052 30H31.8386C32.8507 30 33.6719 29.2802 33.6719 28.3929V22.5H11.6719V28.3929ZM19.0052 26.1161C19.0052 25.8951 19.2115 25.7143 19.4635 25.7143H24.658C24.9101 25.7143 25.1163 25.8951 25.1163 26.1161V27.4554C25.1163 27.6764 24.9101 27.8572 24.658 27.8572H19.4635C19.2115 27.8572 19.0052 27.6764 19.0052 27.4554V26.1161ZM14.1163 26.1161C14.1163 25.8951 14.3226 25.7143 14.5747 25.7143H17.3247C17.5767 25.7143 17.783 25.8951 17.783 26.1161V27.4554C17.783 27.6764 17.5767 27.8572 17.3247 27.8572H14.5747C14.3226 27.8572 14.1163 27.6764 14.1163 27.4554V26.1161ZM33.6719 16.6072V18.2143H11.6719V16.6072C11.6719 15.7199 12.4931 15 13.5052 15H31.8386C32.8507 15 33.6719 15.7199 33.6719 16.6072Z",
    fill: "#6CBECD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullpushcredit);
export default __webpack_public_path__ + "static/media/fullpushcredit.e4c7d9a8a77e96276bb5bcc67bdf14bd.svg";
export { ForwardRef as ReactComponent };